//= require drawing/plugins.js
//= require drawing/modernizr-2.6.2.dev.js
//= require drawing/jquery-1.10.1.min.js
import $ from "jquery";

window.$ = $;

/* LOAD GAME				-------------------------------------------------------------------------------------------------- */
(function ($) {
  $.fn.extend({
    zappelinTekenen: function (options) {

      var defaults = {
        canvasid: 'sketch',
        colors: ['#582b01', '#ffff00', '#f3cf95', '#fe0000', '#ff98cd', '#7c1679', '#ffffff', '#6ccff6', '#0d51b6', '#000000', '#006300'],
        brushes: ['bruin.png', 'geel.png', 'zalm.png', 'rood.png', 'roze.png', 'paars.png', 'wit.png', 'lichtblauw.png', 'blauw.png', 'zwart.png', 'groen.png'],
        backgroundimage: 'assets/background.png'
      };

      var obj;
      var options = $.extend(defaults, options);
      var brushes = options.brushes;
      var colors = options.colors;
      var touchSupported = Modernizr.touch;
      var touchOrClick = Modernizr.touch ? 'touchstart' : 'click';
      var cssTransitions = Modernizr.csstransitions;
      var canvasID = options.canvasid;
      var canvas = $("#" + canvasID);

      var context = canvas.get(0).getContext("2d");
      var backgroundimage = options.backgroundimage;
      var imageObj = new Image();
      var lastMousePoint = {x: 0, y: 0};
      var lastBrushsize = 'potlood-dun';
      var brushsize = 'potlood-dun';
      var brushnr;

      // SOUNDS
      var audioBewaarAfbeelding;
      var audioHoudJeVingerOpHetPlaatje;
      var audioPrintTekening;
      var audioOpnieuwBeginnen;
      var audioWilJeTerug;

      // MOUSE OR TOUCH
      var mouseDownEvent = "mousedown";
      var mouseMoveEvent = "mousemove";
      var mouseUpEvent = "mouseup";

      var mouseMoveHandler;
      var mouseUpHandler;

      if (touchSupported) {
        mouseDownEvent = "touchstart";
        mouseMoveEvent = "touchmove";
        mouseUpEvent = "touchend";
      }

      initColors();
      initCanvas();

      $("#img-sketch").bind(mouseDownEvent, onCanvasMouseDown());
      $('#potlood-dun').css('opacity', 1);
      $('#potlood-dik').css('opacity', 0.4);
      $('#gum').css('opacity', 0.4);

      function initCanvas() {
        canvas.prop('width', $('#drawing').innerWidth());
        canvas.prop('height', $('#drawing').innerHeight());
      }

      // LINE
      context.lineHeight = 4;
      context.lineWidth = 4;
      context.lineCap = "round";

      function initColors() {
        for (var i = 0; i < colors.length; i++) {
          var active;
          if (i == 4) {
            active = 'class="active"';
            $('#mycursor').css('background-image', 'url(assets/' + brushsize + '/' + brushes[i] + ')');
            $('#potlood-dik, #potlood-dun').css('background-image', 'url(assets/potlood-diktes/' + brushes[i] + ')');
            context.strokeStyle = colors[i];
            brushnr = i;
          } else active = '';

          $('#colors').append('<a href="#" ' + active + ' style="background:' + colors[i] + '"></a>');
        }

        $('#colors a').bind(touchOrClick, function (e) {
          if (brushsize == 'gum') {
            brushsize = lastBrushsize;
            $('#' + brushsize).trigger(e);
          }
          $('#colors a').removeClass('active');
          $(this).addClass('active');
          $('#mycursor').css('background-image', 'url(assets/' + brushsize + '/' + brushes[$(this).index()] + ')');
          $('#potlood-dik, #potlood-dun').css('background-image', 'url(assets/potlood-diktes/' + brushes[$(this).index()] + ')');

          context.strokeStyle = colors[$(this).index()];
          brushnr = $(this).index();

          if (checkAndroid())
            galaxyTabFix(1000);
        });

        if (!touchSupported) {
          $('#drawing').mouseleave(function () {
            $('#mycursor').hide();
            return false;
          });
          $('#drawing').mouseenter(function () {
            $('#mycursor').show();
            return false;
          });
          $('#drawing').mousemove(function (e) {
            e.preventDefault();
            var offset = $('#sketch').offset();
            $('#mycursor').css('left', e.clientX - (offset.left - 2)).css('top', e.clientY - (offset.top + 100));
          });
        }
      }

      function onCanvasMouseDown() {
        return function (event) {
          mouseMoveHandler = onCanvasMouseMove();
          mouseUpHandler = onCanvasMouseUp();

          $(document).bind(mouseMoveEvent, mouseMoveHandler);
          $(document).bind(mouseUpEvent, mouseUpHandler);

          updateMousePosition(event);
          updateCanvasByLine(event);

          event.preventDefault();
        }
      }

      function onCanvasMouseMove() {

        return function (event) {
          updateCanvasByLine(event);
          event.preventDefault();
          return false;
        }
      }

      function onCanvasMouseUp(event) {
        return function (event) {
          $(document).unbind(mouseMoveEvent, mouseMoveHandler);
          $(document).unbind(mouseUpEvent, mouseUpHandler);

          self.mouseMoveHandler = null;
          self.mouseUpHandler = null;

          event.preventDefault();
        }
      }

      function updateMousePosition(event) {
        var target;
        if (touchSupported) {
          target = event.originalEvent.touches[0]
        }
        else {
          target = event;
        }

        var offset = canvas.offset();
        lastMousePoint.x = target.pageX - offset.left;
        lastMousePoint.y = target.pageY - offset.top;

        event.preventDefault();
      }

      function updateCanvasByLine(event) {
        context.beginPath();
        context.moveTo(lastMousePoint.x, lastMousePoint.y);
        updateMousePosition(event);
        context.lineTo(lastMousePoint.x, lastMousePoint.y);
        context.stroke();

        event.preventDefault();
      }

      function startIntro() {
        var cssTransitions = Modernizr.csstransitions;
        var touchOrClick = Modernizr.touch ? 'touchstart' : 'click';

        $("#intro").show(0).hide();

        if (cssTransitions) {
          $('#btnstart').addClass('animation');
          $('.overlay', '#intro').css('display', 'block').addClass('animation');
        } else {
          $(".overlay").fadeTo('normal', 0.7);
          $("#btnstart").fadeIn();
        }

        $('#btnstart').bind(touchOrClick, function () {

          $(this).hide();
          var intro = soundManager.createSound({
            id: 'intro',
            url: 'audio/intro_stempelen.mp3',
            multiShot: false,
            volume: 70,
            onfinish: function () {
              this.destruct();

              $("#intro").hide();
            }
          });

          intro.play();

        });
      }

      function clearCanvas() {
        var c = canvas[0];
        context.clearRect(0, 0, c.width, c.height);
        context.fillStyle = "rgba( 255, 255, 255, 1)";
        context.fillRect(0, 0, c.width, c.height);
        $('#img-sketch').css("background-image", "url(" + backgroundimage + ")");
        context.strokeStyle = colors[brushnr];
      }

      function cloneCanvas(oldCanvas) {
        var newCanvas = document.createElement('canvas');
        var context = newCanvas.getContext('2d');

        newCanvas.width = oldCanvas.width;
        newCanvas.height = oldCanvas.height;

        context.drawImage(oldCanvas, 0, 0);

        return newCanvas;
      }

      function saveImage() {
        var oCanvas = cloneCanvas(canvas[0]);
        var context = oCanvas.getContext('2d');

        imageObj = new Image();
        imageObj.crossOrigin = "Anonymous";
        imageObj.src = backgroundimage;
        imageObj.zindex = 100;

        imageObj.onload = function () {
          context.drawImage(imageObj, 0, 0, oCanvas.width, oCanvas.height);
          if (touchSupported) {
            $('#saveimage').show(0);

            var oImgPNG = Canvas2Image.saveAsPNG(oCanvas, true);
            $('#imageoverlay').html('');
            $('#imageoverlay').append(oImgPNG);
            $('#imageoverlay img').css('width', '300px');
            $('#imageoverlay').append(oImgPNG);

            $(".overlay", "#saveimage").fadeTo('normal', 0.7);
            $('#imageoverlay').show();
            $('#closeoverlay').show();

            $('#closeoverlay').bind(touchOrClick, function () {
              $('.overlay').fadeOut('normal');
              $('#imageoverlay').hide();
              $('#closeoverlay').hide();
              if (checkAndroid())
                galaxyTabFix(1000);
            });

            if (checkAndroid())
              galaxyTabFix(1000);

            stopAudio();
            audioHoudJeVingerOpHetPlaatje.play();
          } else {
            var url = options.saveimageurl;
            var fname = 'zappelin-tekening';
            var data = oCanvas.toDataURL("image/png");

            data = data.substr(data.indexOf(',') + 1).toString();

            var dataInput = document.createElement("input");
            dataInput.setAttribute("name", 'imgdata');
            dataInput.setAttribute("value", data);

            var nameInput = document.createElement("input");
            nameInput.setAttribute("name", 'name');
            nameInput.setAttribute("value", fname + '.png');

            var myForm = document.createElement("form");
            myForm.method = 'post';
            myForm.action = url;
            myForm.appendChild(dataInput);
            myForm.appendChild(nameInput);

            document.body.appendChild(myForm);
            myForm.submit();
            document.body.removeChild(myForm);
          }
        };
      }

      function initButtons() {
        $('#clear').bind(touchOrClick, function () {
          if (touchSupported) {
            stopAudio();
            audioOpnieuwBeginnen.play();
          }
          clearCanvas();

          if (checkAndroid())
            galaxyTabFix(1000);
        });

        $('#download').bind(touchOrClick, function () {
          saveImage();
        });
        $("#download").mouseenter(function () {
          if (!touchSupported) {
            stopAudio();
            audioBewaarAfbeelding.play();
          }
        });
        $(".terug").mouseenter(function () {
          if (!touchSupported) {
            stopAudio();
            audioWilJeTerug.play();
          }
        });
        $("#clear").mouseenter(function () {
          if (!touchSupported) {
            stopAudio();
            audioOpnieuwBeginnen.play();
          }
        });
        //$("#print").mouseenter(function() { if (!touchSupported) { stopAudio(); audioPrintTekening.play(); } });

        $('#potlood-dik').bind(touchOrClick, function () {
          context.strokeStyle = colors[brushnr];
          $('#potlood-dun').css('opacity', 0.4);
          $('#gum').css('opacity', 0.4);
          brushsize = 'potlood-dik';
          $('#mycursor').css('background-image', 'url(assets/' + brushsize + '/' + brushes[brushnr] + ')');
          $(this).css('opacity', 1);
          context.lineHeight = 8;
          context.lineWidth = 8;

          if (checkAndroid())
            galaxyTabFix(1000);
        });

        $('#potlood-dun').bind(touchOrClick, function () {
          context.strokeStyle = colors[brushnr];
          $('#potlood-dik').css('opacity', 0.4);
          $('#gum').css('opacity', 0.4);
          brushsize = 'potlood-dun';
          $('#mycursor').css('background-image', 'url(assets/' + brushsize + '/' + brushes[brushnr] + ')');
          $(this).css('opacity', 1);
          context.lineHeight = 4;
          context.lineWidth = 4;

          if (checkAndroid())
            galaxyTabFix(1000);
        });

        $('#gum').bind(touchOrClick, function () {
          $('#potlood-dik').css('opacity', 0.4);
          $('#potlood-dun').css('opacity', 0.4);
          lastBrushsize = brushsize;
          brushsize = 'gum';
          $('#mycursor').css('background-image', 'url(assets/gum.png)');
          $(this).css('opacity', 1);
          context.lineHeight = 30;
          context.lineWidth = 30;
          context.strokeStyle = '#ffffff';

          if (checkAndroid())
            galaxyTabFix(1000);
        });

      }

      function checkAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
      }

      function isiPhone() {
        return ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPod") != -1));
      }

      function galaxyTabFix(sec, interval) {
        if (interval)
          setInterval(function () {
            $('body').css("color", "#ffff" + Math.floor((Math.random() * 100)))
          }, sec);
        else
          setTimeout(function () {
            $('body').css("color", "#ffff" + Math.floor((Math.random() * 100)))
          }, sec);
      }

      function stopAudio() {
        audioBewaarAfbeelding.stop();
        audioHoudJeVingerOpHetPlaatje.stop();
        audioPrintTekening.stop();
        audioOpnieuwBeginnen.stop();
        audioWilJeTerug.stop();
      }

      return this.each(function () {
        obj = $(this);

        audioBewaarAfbeelding = new Howl({urls: ['audio/bewaarafbeelding.mp3', 'audio/bewaarafbeelding.ogg']});
        audioHoudJeVingerOpHetPlaatje = new Howl({urls: ['audio/houdjevingerophetplaatje.mp3', 'audio/houdjevingerophetplaatje.ogg']});
        audioPrintTekening = new Howl({urls: ['audio/printtekening.mp3', 'audio/printtekening.ogg']});
        audioOpnieuwBeginnen = new Howl({urls: ['audio/opnieuwbeginnen.mp3', 'audio/opnieuwbeginnen.ogg']});
        audioWilJeTerug = new Howl({urls: ['audio/wiljeterug.mp3', 'audio/wiljeterug.ogg']});

        startIntro();
        initButtons();
        clearCanvas();

        if (isiPhone()) {
          $('head').append('<meta name="viewport" content="user-scalable=0">');
        } else if (!checkAndroid()) {
          $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0">');
        } else {
          galaxyTabFix(5000, true);
          galaxyTabFix(2000);
        }
      });

    }
  });
})($);
